import { SafetyLocalStorage } from '@mail-core/std';
import { isSameDay, startOfDay } from 'date-fns';
import { USER_EMAIL } from 'reactApp/appHelpers/configHelpers';
import { freemiumEndingModals, isHardFreemium, isSoftFreemium } from 'reactApp/appHelpers/featuresHelpers/features/freemium';

const MODAL_ENDING_CLOSED_KEY = 'freemium_ending_modal_closed';
const MODAL_ENDED_CLOSED_KEY = 'freemium_ended_modal_closed';

const lStorage = new SafetyLocalStorage({});
const email = USER_EMAIL;

export enum FreemiumModalState {
    NONE = 'none',
    ENDING = 'ending',
    ENDED = 'ended',
}

export const shouldShowEndingModal = (freemiumDays: number, _expiresDate: number | null): boolean => {
    if (!freemiumEndingModals) {
        return false;
    }

    if (!isSoftFreemium && !isHardFreemium) {
        return false;
    }

    return freemiumDays === 1;
};

export const shouldShowEndedModal = (freemiumDays: number, expiresDate: number | null): boolean => {
    if (!freemiumEndingModals) {
        return false;
    }

    if (!isSoftFreemium && !isHardFreemium) {
        return false;
    }

    if (freemiumDays !== 0) {
        return false;
    }

    if (!expiresDate) {
        return false;
    }

    const today = startOfDay(new Date());
    const expiresDay = startOfDay(expiresDate);
    if (!isSameDay(today, expiresDay)) {
        return false;
    }

    return true;
};

export const getFreemiumModalState = (freemiumDays: number, expiresDate: number | null): FreemiumModalState => {
    if (shouldShowEndedModal(freemiumDays, expiresDate)) {
        return FreemiumModalState.ENDED;
    }

    if (shouldShowEndingModal(freemiumDays, expiresDate)) {
        return FreemiumModalState.ENDING;
    }

    return FreemiumModalState.NONE;
};

export const markEndingModalClosed = (): void => {
    lStorage.setItem(`${email}|${MODAL_ENDING_CLOSED_KEY}`, 'true');
};

export const markEndedModalClosed = (): void => {
    lStorage.setItem(`${email}|${MODAL_ENDED_CLOSED_KEY}`, 'true');
};
